import * as React from 'react';
import { cloneDeep } from 'lodash';
import { API, USER_CHANNEL_NAME_MAP, RESPONSE_CHANNEL_TYPE, contentFontColor } from '@config/index';
import { NiButton, NiSelect, NiInput, niConfirm } from '@component/index';
import { PaperClipOutlined, HistoryOutlined, DownloadOutlined, RedoOutlined, BugOutlined, LeftOutlined, FileDoneOutlined } from '@ant-design/icons';
import { Input, message, Drawer, Dropdown, Menu, Space, Modal, Popover } from 'antd';
import reactJsonView from 'react-json-view';
import '@style/component/try-it-now/index.less';
import { getLocale, localizedString } from '@locale/index';
import { globalModel, PayloadInfo } from '@reducer/global';
import { DispatchProp } from 'react-redux';
import { frameEventHistory, addNewFrameEvent, instance, getUserId, getAgentId, getOrgId, getUserInfo } from '@lib/index';
import { TryItNowSession } from './session';
import { TestCaseTurn, testCaseTurnToServer } from '@interface/index';
import TextArea from 'antd/lib/input/TextArea';
import { TestCaseComp } from '@page/test-case';


const ReactJson = reactJsonView;

type TryItNowProps = DispatchProp & {
  global: PayloadInfo;
  visible: boolean;
  onClose?: () => void;
};

export interface TryItNowState {
  data: any;
  query: string;
  structureData: string;
  loading: boolean;
  structureInputVisible: boolean;
  channel: string;
  historyVisible?: boolean;
  testCaseModalVisible: boolean;
  waitingTurn?: TestCaseTurn;
  userImg?: HTMLImageElement;
}

const defaultState: TryItNowState = {
  data: undefined,
  query: '',
  structureData: '',
  loading: false,
  structureInputVisible: false,
  testCaseModalVisible: false,
  channel: RESPONSE_CHANNEL_TYPE.RESTFUL
};


function getImageFileFromUrl(url: string) {
  // imageName一定要带上后缀

}

class TryItNowComp extends React.Component<TryItNowProps, TryItNowState> {
  public state: TryItNowState = { ...defaultState };
  $structureInput: any;

  render() {
    const { visible, onClose, global } = this.props;
    const {
      data,
      loading,
      structureData,
      channel,
      query,
      structureInputVisible,
      historyVisible,
      testCaseModalVisible,
      waitingTurn
    } = this.state;

    let eventHistory = frameEventHistory();
    if (structureData && structureData.length) {
      eventHistory = eventHistory.filter((h: string) => {
        return h.toLocaleLowerCase().indexOf(structureData.toLocaleLowerCase()) !== -1;
      });
    }

    if (eventHistory.length > 10) {
      eventHistory = eventHistory.slice(0, 10);
    }

    return (

      <Drawer
        className="try-it-now-drawer"
        open={visible}
        width={550}
        closable={false}
        onClose={() => {
          if (onClose) {
            onClose();
          }
        }}
        footer={
          <div className="try-it-now-footer">
            {
              global.demoConnected
                ? <>
                  <div className={`search-div`}>
                    <Input
                      autoFocus
                      placeholder={localizedString('demo_placeholder')}
                      value={query}
                      onPressEnter={this.handleQuery}
                      onChange={(e: any) => {
                        this.setState({ query: e.target.value });
                      }}
                      ref={(val: any) => ((this as any).queryInput = val)}
                      addonAfter={
                        <Popover
                          content="Structure Input"
                          placement="topRight"
                        >
                          <PaperClipOutlined
                            onClick={() => {
                              this.setState({ structureInputVisible: !structureInputVisible });
                            }}
                          />
                        </Popover>
                      }
                    />
                  </div>
                  {structureInputVisible &&
                    <div className="search-div">
                      <Dropdown
                        trigger={[]}
                        overlayStyle={{ width: 0 }}
                        open={visible && historyVisible}
                        placement="bottomLeft"
                        overlay={
                          <Menu>
                            {eventHistory.map((h: string) =>
                              <Menu.Item
                                key={h}
                                className="history-menu-item"
                                onClick={(e: any) => {
                                  this.$structureInput.focus();
                                  this.setState({ structureData: h });
                                }}
                              >
                                <HistoryOutlined className="history-icon" />
                                <p className="history-menu-item-p" >{h}</p>
                              </Menu.Item>
                            )}
                          </Menu>
                        }
                      >
                        <Input.TextArea
                          className="footer-structure-input"
                          autoFocus
                          onFocus={() => {
                            if (!historyVisible) {
                              this.setState({ historyVisible: true });
                            }
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              this.setState({ historyVisible: false });
                            }, 250);
                          }}
                          placeholder="Input the structure event"
                          value={structureData}
                          onPressEnter={this.handleQuery}
                          onChange={(e: any) => {
                            this.setState({ structureData: e.target.value, historyVisible: true });
                          }}
                          ref={(val: any) => {
                            this.$structureInput = val;
                          }}
                        />
                      </Dropdown>
                    </div>}
                </>
                : <NiButton
                  onClick={this.handleQuery}
                  loading={loading}
                >
                  CONNECT
                </NiButton>
            }
          </div>
        }
      >
        <Drawer
          className="try-it-now-drawer"
          open={testCaseModalVisible}
          width={600}
          closable={false}
          onClose={() => {
            this.setState({ testCaseModalVisible: false });
          }}
        >
          <div
            className="title"

          >
            <span onClick={() => {
              this.setState({ testCaseModalVisible: false });
            }}>
              <LeftOutlined />
              <span className="structure-label">Test Cases</span>
            </span>
          </div>
          {testCaseModalVisible &&
            <TestCaseComp />
          }
        </Drawer>
        <div className="bg-demo">
          {
            !global.demoConnected &&
            <div className="structure-div">
              <div
                className="title"

              >
                <span onClick={() => {
                  this.setState({ structureInputVisible: !structureInputVisible });
                }}>
                  <PaperClipOutlined />
                  <span className="structure-label">Structure input</span>
                </span>
                <span onClick={() => {
                  this.setState({ testCaseModalVisible: true });
                }}>
                  <FileDoneOutlined />
                  <span className="structure-label" style={{ marginLeft: 8 }}>Test Cases</span>
                </span>
              </div>

              <div className="search-div">
                <Dropdown
                  trigger={[]}
                  overlayStyle={{ width: 0 }}
                  open={visible && historyVisible}
                  placement="bottomLeft"
                  overlay={
                    <Menu>
                      {eventHistory.map((h: string) =>
                        <Menu.Item
                          key={h}
                          className="history-menu-item"
                          onClick={(e: any) => {
                            this.$structureInput.focus();
                            this.setState({ structureData: h });
                          }}
                        >
                          <HistoryOutlined className="history-icon" />
                          <p className="history-menu-item-p" >{h}</p>
                        </Menu.Item>
                      )}
                    </Menu>
                  }
                >
                  <TextArea
                    autoSize
                    onFocus={() => {
                      if (!historyVisible) {
                        this.setState({ historyVisible: true });
                      }
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        this.setState({ historyVisible: false });
                      }, 250);
                    }}
                    placeholder="Input the structure event"
                    value={structureData}
                    onPressEnter={this.handleQuery}
                    onChange={(e: any) => {
                      this.setState({ structureData: e.target.value, historyVisible: true });
                    }}
                    ref={(val: any) => {
                      this.$structureInput = val;
                    }}
                  />
                </Dropdown>
              </div>
            </div>
          }
          {
            global.demoConnected &&
            <>
              <div className="title">
                <NiSelect
                  value={channel}
                  onChange={(value: string) => {
                    this.setState({
                      channel: value
                    });
                  }}
                >
                  {
                    (data &&
                      data.response &&
                      Object.keys(data.response)
                        .filter((key: string) => key !== '*')
                      || [
                        RESPONSE_CHANNEL_TYPE.RESTFUL
                      ]).map((key: string) => {
                        return <NiSelect.Option
                          key={key}
                          value={key}
                        >
                          {USER_CHANNEL_NAME_MAP[key] || key}
                        </NiSelect.Option>;
                      })
                  }
                </NiSelect>
                <Space size={16}>
                  <Popover key="view-log" content={localizedString('view_log')} placement="left">
                    <a
                      key="debug"
                      style={{ color: contentFontColor }}
                      href={`${window.location.origin}/view-log?org_id=${getOrgId()}&agent_id=${getAgentId()}&user_id=${getUserId()}`} target="_blank">
                      <BugOutlined
                      />
                    </a>
                  </Popover>
                  <Popover key="save" content={localizedString('test_case_save')} placement="left">
                    <DownloadOutlined onClick={() => {
                      this.handleSaveTestCase();
                    }} />
                  </Popover>
                  <Popover key="test-case-list" content={'Test Cases'} placement="left">
                    <FileDoneOutlined onClick={() => {
                      this.setState({ testCaseModalVisible: true });
                    }} />
                  </Popover>
                  <Popover key="reset" content={localizedString('demo_clear_context')} placement="left">
                    <RedoOutlined onClick={() => {
                      this.onClear();
                    }} />
                  </Popover>
                </Space>
              </div>
              <div className="section response">
                <TryItNowSession
                  turns={waitingTurn ? [...global.testCaseTurns, waitingTurn] : global.testCaseTurns}
                  channel={channel}
                />
              </div>
            </>
          }
        </div>

      </Drawer >
    );
  }

  renderContent = (src: any) => {
    if (typeof src === 'object') {

      return <ReactJson
        src={src}
        name={false}
        displayObjectSize={false}
        displayDataTypes={false}
      />;
    }

    return String(src);
  }

  handleQuery = () => {

    const { dispatch, global } = this.props;
    const { structureData, loading, query } = this.state;
    if (global.demoConnected && (!query || !query.length) && (!structureData || !structureData.length)) {
      message.warning(localizedString('demo_placeholder'));
      return;
    }

    if (loading) {
      return;
    }

    if (query.length > 0) {
      this.setState({
        waitingTurn: {
          query
        },
        query: ''
      }, () => {
        const ele: HTMLElement | null = document.getElementById('try-it-now-session-wrap');
        if (ele) {
          ele.scrollTo(0, ele.scrollHeight);
        }
      });
    }

    this.setState({
      loading: true,
      historyVisible: false
    });

    if (this.$structureInput) {
      this.$structureInput.blur();
    }

    const s = structureData;

    API.common
      .getQuery(global.demoConnected ? query : '', s, !global.demoConnected)
      .then((res: any) => {
        const data = this.parseData(res);

        if (structureData.length) {
          addNewFrameEvent(structureData);
        }

        this.setState({ waitingTurn: undefined });

        if (!global.demoConnected) {

          dispatch({
            type: 'global/update_state',
            payload: {
              demoConnected: true,
              testCaseTurns: [{
                query: '',
                structureInput: s,
                reply: JSON.stringify(res.response),
                stateInfo: JSON.stringify(res.state)
              }]
            }
          });
        } else {
          dispatch({
            type: 'global/update_state',
            payload: {
              demoConnected: true,
              testCaseTurns: [
                ...global.testCaseTurns,
                {
                  query,
                  structureInput: s,
                  reply: JSON.stringify(res.response),
                  stateInfo: JSON.stringify(res.state)
                }
              ]
            }
          });
        }

        this.setState({
          data,
          query: '',
          structureData: '',
          loading: false,
          structureInputVisible: false
        }, () => {
          const ele: HTMLElement | null = document.getElementById('try-it-now-session-wrap');
          if (ele) {
            ele.scrollTo(0, ele.scrollHeight);
          }
        });
      })
      .catch((err: any) => {
        if (err.message) {
          niConfirm({
            width: '60%',
            title: localizedString('common_error_info'),
            content: <pre style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all'
            }}>{err.message}</pre>

          });
        } else {
          message.warning(err.message);
        }

        if (structureData.length) {
          addNewFrameEvent(structureData);
        }

        this.setState({
          waitingTurn: undefined,
          loading: false
        });

        throw new Error(err.message);
      });
  };

  parseData(data: any) {

    const clone: any = cloneDeep(data) || {};
    delete clone.response;

    return {
      sections: Object.keys(clone).map((key: string) => (clone[key] && {
        title: key,
        content: clone[key]
      })).filter(Boolean),
      response: data.response
    };
  }

  onClear = async (withoutTip?: boolean) => {
    const { dispatch } = this.props;
    // await API.common.clearDemo().catch((err: any) => {
    //   message.warning(err.message);
    //   throw new Error(err.message);
    // });

    this.setState({
      data: undefined,
      query: '',
      structureData: ''
    });

    if (!withoutTip) {
      dispatch({
        type: 'global/update_state',
        payload: {
          demoConnected: false
        }
      });
    }
  };

  testCaseName = '';
  confirmDestory = () => {
    // do nothing
  }

  saveTestCaseConfirm = (close: () => void) => {
    const { global } = this.props;
    if (this.testCaseName.length === 0) {
      return;
    }
    this.setState({ loading: true });
    API.testCase.save(this.testCaseName,
      global.testCaseTurns.map(testCaseTurnToServer))
      .then((res: any) => {
        this.setState({ loading: false });
        instance.emit('test_case_add');
        close();
      })
      .catch((err: Error) => {
        this.setState({ loading: false });
        message.error(err.message);
        throw err;
      });
  };

  handleSaveTestCase = () => {
    const { global } = this.props;

    this.testCaseName = '';
    this.confirmDestory = niConfirm({
      title: localizedString('test_case_save'),
      content: <NiInput
        id="test-case-name-input"
        ref={(a: any) => {
          setTimeout(() => {
            if (a) {
              a.focus();
            }
          }, 100);
        }}
        placeholder={localizedString('test_case_name_placeholder')}
        defaultValue={this.testCaseName}
        onChange={(e: any) => {
          this.testCaseName = e.target.value;
        }}
        onPressEnter={() => {
          this.saveTestCaseConfirm(this.confirmDestory);
        }}
      />,
      onOk: this.saveTestCaseConfirm
    }).destroy;
  }
}

export const TryItNow = globalModel.connect()(TryItNowComp as any);

